import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader, Col, Row, FormGroup, Form } from 'reactstrap';
import InputGroup from '../../../components/cms/form/inputGroup';
import SubmitButtons from '../../../components/cms/form/submitButtons';
import InputFile from '../../../components/cms/form/inputFile';
import PreviewImage from '../../../components/previewImage';
import VideoService from '../../../services/video.service';
import {Link} from "react-router-dom";
import CompanyService from "../../../services/company.service";
import moment from 'moment';

const twoCols = { xs: 12, md: 6 };
const threeCols = { xs: 6, md: 4 };

const Item = ({
  t,
  onChange,
  onSubmit,
  errors,
  formData,
  title,
  animationsLists,
  isSubmitting,
  isSubmittingRedirect,
  paymentStatusList,
  paymentTypesList,
  licenseList,
  licenceTimeTypes,
  imageSrc,
  searchCompany,
  onChangeCompanyInput,
}) => (
  <div>
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-building pr-2" />{title}</strong>
          </CardHeader>
          <CardBody>
            <Form onSubmit={onSubmit(true)}>
              <Row>
                <Col md={9}>
                  <InputGroup
                    name="title"
                    label={t('Title')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.title}
                    icon="fa fa-building"
                  />
                  <InputGroup
                    name="brand_title"
                    label={t('Brand title')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.brand_title}
                    icon="fa fa-building"
                  />
                  <InputGroup
                    id="parent_id"
                    label={() => {
                      if (!formData.parent_id) return t('Main company');
                      return (<Link to={CompanyService.getUpdateUrl(formData.parent_id.value)}>{t('Main company')}</Link>);
                    }}
                    name="parent_id"
                    placeholder={t('Main company')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.parent_id}
                    icon="fa fa-group"
                    type="async"
                    loadOptions={searchCompany}
                    onInputChange={onChangeCompanyInput}
                    isMulti={false}
                  />
                  <InputGroup
                    label={t('Animations lists')}
                    name="animationsLists"
                    type="select2"
                    onChange={onChange}
                    errors={errors}
                    value={formData.animationsLists}
                    options={animationsLists}
                    empty="-"
                    icon="fa fa-star"
                    isMulti
                  />
                  <InputGroup
                    label={t('Disabled export types')}
                    name="disabledExportTypes"
                    type="select2"
                    onChange={onChange}
                    errors={errors}
                    value={formData.disabledExportTypes}
                    options={VideoService.getTypeOptions(t)}
                    empty="-"
                    icon="fa fa-play"
                    isMulti
                  />
                  <FormGroup row className="my-0">
                    <Col {...twoCols}>
                      <InputGroup
                        name="zip_code"
                        label={t('Zip code')}
                        onChange={onChange}
                        errors={errors}
                        value={formData.zip_code}
                        icon="fa fa-location-arrow"
                      />
                    </Col>
                    <Col {...twoCols}>
                      <InputGroup
                        name="address"
                        label={t('Address')}
                        onChange={onChange}
                        errors={errors}
                        value={formData.address}
                        icon="fa fa-address-book"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row className="my-0">
                    <Col {...twoCols}>
                      <InputGroup
                        name="city"
                        label={t('City')}
                        onChange={onChange}
                        errors={errors}
                        value={formData.city}
                        icon="fa fa-location-arrow"
                      />
                    </Col>
                    <Col {...twoCols}>
                      <InputGroup
                        name="country"
                        label={t('Country')}
                        onChange={onChange}
                        errors={errors}
                        value={formData.country}
                        icon="fa fa-address-book"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row className="my-0">
                    <Col {...threeCols}>
                      <InputGroup
                        name="status"
                        label={t('Status')}
                        onChange={onChange}
                        errors={errors}
                        type="checkbox"
                        value={1}
                        checked={formData.status}
                      />
                    </Col>
                    <Col {...threeCols}>
                      <InputGroup
                        name="allow_csv"
                        label={t('Allow CSV')}
                        onChange={onChange}
                        errors={errors}
                        type="checkbox"
                        value={1}
                        checked={formData.allow_csv}
                      />
                    </Col>
                    <Col {...threeCols}>
                      <InputGroup
                        name="allow_design_presets"
                        label={t('Allow design presets')}
                        onChange={onChange}
                        errors={errors}
                        type="checkbox"
                        value={1}
                        checked={formData.allow_design_presets}
                      />
                    </Col>
                  </FormGroup>
                  <InputGroup
                    name="webhook_url_export_is_ready"
                    label={t('Webhook url (export is ready)')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.webhook_url_export_is_ready}
                    icon="fa fa-building"
                  />
                  <InputGroup
                    name="metadata"
                    label={t('Metadata')}
                    onChange={onChange}
                    errors={errors}
                    value={formData.metadata}
                    icon="fa fa-info"
                    type="textarea"
                  />
                  <FormGroup row className="my-0">
                    <Col {...twoCols}>
                      <InputGroup
                        label={t('License')}
                        name="license_id"
                        type="select"
                        empty="-"
                        onChange={onChange}
                        errors={errors}
                        value={formData.license_id}
                        options={licenseList}
                        icon="fa fa-cog"
                      />
                    </Col>
                    <Col {...twoCols}>
                      <InputGroup
                        label={t('Payment period')}
                        name="license_time_type"
                        type="select"
                        onChange={onChange}
                        errors={errors}
                        value={formData.license_time_type}
                        options={licenceTimeTypes}
                        icon="fa fa-cog"
                      />
                    </Col>
                  </FormGroup>
                  <FormGroup row className="my-0">
                    <Col {...twoCols}>
                      <InputGroup
                        label={t('Payment status')}
                        name="payment_status"
                        type="select"
                        onChange={onChange}
                        errors={errors}
                        value={formData.payment_status}
                        options={paymentStatusList}
                        icon="fa fa-cog"
                      />
                    </Col>
                    <Col {...twoCols}>
                      <InputGroup
                        label={t('Payment types')}
                        name="payment_type"
                        type="select"
                        onChange={onChange}
                        errors={errors}
                        value={formData.payment_type}
                        options={paymentTypesList}
                        icon="fa fa-cog"
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <div className="">
                    <InputFile id="logo">
                      <PreviewImage src={imageSrc} className="" alt="img" height="120" />
                    </InputFile>
                  </div>
                  <hr/>
                  <InputGroup
                    name="is_whitelabel"
                    label={t('is whitelabel')}
                    onChange={onChange}
                    errors={errors}
                    type="checkbox"
                    value={1}
                    checked={formData.is_whitelabel}
                  />
                  <InputGroup
                    name="can_change_animation_structure"
                    label={t('Can edit animation structure')}
                    onChange={onChange}
                    errors={errors}
                    type="checkbox"
                    value={1}
                    checked={formData.can_change_animation_structure}
                  />
                  <InputGroup
                    label={t('Trail period end at')}
                    name="free_trial_expired_at"
                    type="datetime"
                    onChange={onChange}
                    errors={errors}
                    value={moment(formData.free_trial_expired_at).format('YYYY-MM-DD HH:mm:ss')}
                    icon="fa fa-calendar"
                    inputProps={{ disabled: true }}
                  />
                  <hr/>
                  <div>Tokens: {formData.tokens}</div>
                  <Link to={"/users/companies/"+formData.id+"/tokens-balance"}>Manage tokens</Link>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <SubmitButtons
                    isSubmitting={isSubmitting}
                    onSubmit={onSubmit}
                    isSubmittingRedirect={isSubmittingRedirect}
                  />
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Item.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isSubmittingRedirect: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string.isRequired,
};

export default Item;



// WEBPACK FOOTER //
// ./src/views/companies/item/Item.jsx